import { hasBufferedBehaviorViews } from '~/composables/useBehaviorEventTracking/offlineStorage';
import { useLogger } from '~/composables/useLogger';

/**
 * Syncs buffered pre-login property_viewed behavior events.
 * Isolated from Portal property-view sync (engagement) — this path posts to
 * /api/behavior-events only.
 *
 * Runs on the logged-out → logged-in edge and also when the page opens
 * already logged in. A WebView reload after OTP often restores the session
 * cookie without emitting that edge, which used to leave the buffer unread.
 */
export default defineNuxtPlugin(nuxtApp => {
	const logger = useLogger('BehaviorEventsSync');

	function scheduleSync(): void {
		if (!hasBufferedBehaviorViews()) return;

		void import('~/composables/useBehaviorEventTracking')
			.then(m =>
				nuxtApp.runWithContext(() => {
					m.useBehaviorEventTracking().syncOfflineBehaviorViews();
				})
			)
			.catch((error: unknown) => {
				logger.error('syncOfflineBehaviorViews failed', {
					operation: 'syncOfflineBehaviorViews',
					error
				});
			});
	}

	nuxtApp.hook('app:suspense:resolve', () => {
		const { loggedIn } = useUserSession();

		if (loggedIn.value) scheduleSync();

		watch(loggedIn, (isLoggedIn, wasLoggedIn) => {
			if (!isLoggedIn || wasLoggedIn) return;
			scheduleSync();
		});
	});
});
